const StatsNoticeRecord = () => import('@/views/main/noticeRecord/stats/index.vue')
export default {
  path: '/main/noticeRecord/stats',
  name: 'StatsNoticeRecord',
  component: StatsNoticeRecord,
  children: []
}
